export const chatPaths = {
  chatCollection: 'vkleyka_chat',
  messagesSubCollection: 'chatMessages',
  storageAttachmentsFolder: 'chatDocs',
  // userChatDocumentField: "messages", // TODO: Delete in future;
}
